
const ACTIVE_CLASS = 'is-active';
const TEMPLATE_PATH = '/';

//Динамическое событие по элементу
function on(event, object, func = function () { }) {
	document.addEventListener(event, function (e) {
		const eTarget = e.target.closest(object);
		if (eTarget == null) return;
		func.call(eTarget, e);
	});
}

//Вызывает асинхронные скрипты
async function loadScript(src, func = false) {
	const script = document.createElement('script');
	script.src = src;
	document.body.append(script);
	if (func) script.onload = () => func();
}

//Ссылка по якорям
function clickAnchors() {
	on('click', 'a[href^="#"]', function (e) {
		e.preventDefault();
		const element = document.getElementById(this.getAttribute('href').substr(1));
		if (!element) return;
		element.scrollIntoView({
			behavior: 'smooth',
			block: 'start'
		});
	});
}
function moveElements() {
	const preffix = 'movedIn';
	for (let moveElement of document.querySelectorAll('[data-move]')) {
		let data = moveElement.dataset,
			windowWidth = window.innerWidth,
			dataSize = (data.move) ? +data.move : 576,
			dataBreak = (data.break) ? +data.break : false,
			toElement = (data.to) ? document.getElementById(data.to) : false,
			oldPosition = document.getElementById(preffix + data.to);
		if (!toElement) return;
		if (windowWidth < dataSize && !oldPosition && windowWidth >= dataBreak) {
			let newOldPosition = document.createElement('div');
			newOldPosition.id = preffix + data.to;
			newOldPosition.style.display = 'none';
			moveElement.before(newOldPosition);
			toElement.append(moveElement);
		}
		else if ((windowWidth >= dataSize || (dataBreak && dataBreak > windowWidth)) && oldPosition) {
			if (!oldPosition) return;
			oldPosition.after(moveElement);
			oldPosition.remove();
		}
	}
}

//Обрабатывает контент модальных окон, которые передаются в парметре data-content.
function initModalPlaceholder(prefix = '.modal__') {
	on('click', '[data-fancybox][data-src*="#"]', function () {
		const dataContent = this.dataset.content,
			modalObject = document.getElementById(this.dataset.src.substr(1));
		if (!modalObject) return;
		let customContent = [];
		if (dataContent) {
			try { customContent = JSON.parse(`{${dataContent}}`); }
			catch (error) { }
		}
		for (let defaultElement of modalObject.querySelectorAll('[data-default]')) {
			let defaultValue = defaultElement.dataset.default;
			if (defaultElement.nodeName.toLowerCase() == 'input') defaultElement.value = defaultValue;
			else defaultElement.innerHTML = defaultValue;
		}
		for (let customItem in customContent) {
			let divDOM = modalObject.querySelector(prefix + customItem),
				inputDOM = modalObject.querySelector(`input[name="${customItem}"]`);
			if (divDOM) divDOM.innerHTML = customContent[customItem];
			if (inputDOM) inputDOM.value = customContent[customItem];
		}
	});
}

// Добавляет CSS стили для элмента в формате JSON
function css(element, css) {
	for (var style in css) {
		element.style[style] = css[style];
	}
}

// Клик вне блока

function outsideClick(element, func) {
	element = (typeof (element) == 'string') ? document.querySelector(element) : element;

	document.addEventListener('click', (e) => {
		const withinBoundaries = e.composedPath().includes(element);
		if (!withinBoundaries) {
			func(element);
		}
	})
}

const INPUT_INIT = 'input-initialized';
const INPUT_IGNORE = 'input-ignore';
function setPhonesMask() {
	for (let phone of document.querySelectorAll(`input[type="tel"]:not(.${INPUT_INIT}):not(.${INPUT_IGNORE})`)) {
		phone.addEventListener('keydown', function (e) {
			if (e.key == undefined) return;
			if (['Delete', 'Backspace', 'Enter'].includes(e.key) || e.key.match(/^arrow/i)) return;
			if (!e.altKey && !e.ctrlKey && !e.shiftKey && e.key.match(/\D/)) e.preventDefault();
		});
		phone.addEventListener('paste', function () {
			this.dispatchEvent(new Event('input'));
		});
		phone.addEventListener('input', function (e) {
			let value = this.value.replace(/\D/ig, '').substr(0, 13);
			if (value[0] == '9') value = `7${value}`;
			let rusFormat = [7, 8, 9].includes(+value[0]),
				result = '',
				startPosition = ((e.inputType && e.inputType.match(/^deleteContent/)) || (this.selectionStart < this.value.length)) ? this.selectionStart : false;
			for (let idx in value) {
				idx = +idx;
				let num = value[idx];
				if (idx == 0) {
					if (num == 8) result += '8';
					else if (num == 9) result += '+7 (9';
					else result += `+${num}`;
				}
				else {
					if (rusFormat) {
						if (idx == 1) result += ` (${num}`;
						else if ([2, 3, 5, 6, 8, 10].includes(idx)) result += `${num}`;
						else if ([7, 9].includes(idx)) result += `-${num}`;
						else if (idx == 4) result += `) ${num}`;
					}
					else result += `${num}`;
				}
			}
			this.value = result;
			if (startPosition && value.length < 11 && rusFormat) {
				this.selectionStart = startPosition;
				this.selectionEnd = startPosition;
			}
		});
		phone.classList.add(INPUT_INIT);
	}
}

function isMobile() {
	return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) ? true : false;
}

function initViberLink() {
	if (!isMobile()) return;
	const viberLink = document.querySelector('a[href^="viber://"]');
	if (viberLink) {
		const url = new URL(viberLink.href),
			number = url.searchParams.get('number').replace(/\D/, '');
		if (number) viberLink.href = `viber://add?number=${number}`;
	}
}

// function pageUp() {
// 	const pageUpBtn = document.getElementById('pageup'),
// 		topShow = 280,
// 		scrollPosition = window.scrollY,
// 		documentFooter = document.querySelector('footer'),
// 		footerHeight = documentFooter ? documentFooter.offsetHeight : 0;
// 	if (!pageUpBtn) return;
// 	if (scrollPosition > topShow && scrollPosition < document.body.offsetHeight - window.innerHeight - footerHeight) pageUpBtn.classList.add(ACTIVE_CLASS);
// 	else pageUpBtn.classList.remove(ACTIVE_CLASS);
// }

// document.addEventListener('scroll', function () {
// 	pageUp();
// });

function setMap() {
  try {
    ymaps.ready(() => {
      for (let mapContainer of document.querySelectorAll('.map')) {
        let id = mapContainer.getAttribute('id'),
        data = mapContainer.dataset,
        mapCenter = JSON.parse(data.center),
        mapCoord = data.coord ? JSON.parse(data.coord) : mapCenter,
        mapZoom = data.zoom,
        mapTitle = data.title,
					map = new ymaps.Map(id, {
						center: mapCenter,
						zoom: mapZoom,
						controls: ['zoomControl', 'fullscreenControl', 'typeSelector', 'trafficControl', 'geolocationControl']
					}),
					pin = new ymaps.Placemark(mapCoord, {
						hintContent: mapTitle
					}, {
						iconLayout: 'default#image'
					});
				map.behaviors.disable(['scrollZoom']);
				map.geoObjects.add(pin);
				setMapCenter();
				function setMapCenter() {
          (mapContainer.offsetWidth < 992) ? map.setCenter(mapCoord) : map.setCenter(mapCenter);
				}
				window.addEventListener('resize', setMapCenter);
			}
		});
	} catch (e) {
		console.log('Yandex Map is not initiated');
	}
}

document.addEventListener('DOMContentLoaded', function () {
  // pageUp();
  clickAnchors();
  moveElements();
  setPhonesMask();
  initModalPlaceholder();
  initViberLink();
  loadScript('//api-maps.yandex.ru/2.1/?lang=ru_RU', setMap);
});

const mobileMenu = document.getElementById("mobile-menu");
const burgerMenu = document.getElementById("burger");
const overlayMenu = document.querySelector(".overlay");
const mobileMenuLinks = mobileMenu.querySelectorAll('a');

const toggleMenu = () => {
   mobileMenu.classList.toggle("active");
   overlayMenu.classList.toggle("active");
   burgerMenu.classList.toggle("active");
};

const closeMenu = () => {
	mobileMenu.classList.remove('active');
	overlayMenu.classList.remove('active');
	burgerMenu.classList.remove('active');
};

burgerMenu.addEventListener("click", toggleMenu);
overlayMenu.addEventListener("click", toggleMenu);


document.addEventListener('DOMContentLoaded', () => {
	const line = document.querySelector('.progress-line__item');

	const progressAnimation = () => {
		let scrollTop = window.scrollY;
		let windowHeight = window.innerHeight;
		let siteHeight = document.documentElement.scrollHeight;
		let percentageProgress = Math.floor(scrollTop / (siteHeight - windowHeight) * 100);
		line.style.width = `${percentageProgress}%`;
	};

	progressAnimation();
	window.addEventListener('scroll', () => {
		progressAnimation();
	});
});

document.querySelector('.search_form-ico').addEventListener('click', function() {
  var searchForm = document.querySelector('.search_form');
  searchForm.classList.toggle('show');

  var searchIcon = document.querySelector('.search_form-ico use');
  if (searchForm.classList.contains('show')) {
    searchIcon.setAttribute('xlink:href', './img/ico.svg#search_close');

    var menuElements = document.querySelectorAll('.menu');
    menuElements.forEach(function(menuElement) {
      menuElement.style.opacity = '0';
    });

    var oilSelectionElements = document.querySelectorAll('.oil_selection');
    oilSelectionElements.forEach(function(oilSelectionElement) {
      oilSelectionElement.style.opacity = '0';
    });
  } else {
    searchIcon.setAttribute('xlink:href', './img/ico.svg#search_open');

    var menuElements = document.querySelectorAll('.menu');
    menuElements.forEach(function(menuElement) {
      menuElement.style.opacity = '1';
    });

    var oilSelectionElements = document.querySelectorAll('.oil_selection');
    oilSelectionElements.forEach(function(oilSelectionElement) {
      oilSelectionElement.style.opacity = '1';
    });
  }
});


document.addEventListener("DOMContentLoaded", function() {
  var header = document.querySelector('.main_wrapper header');
  var breadcrumbs = document.getElementById("breadcrumbs");
  var isMainWrapper = document.querySelector('.wrapper').classList.contains('main_wrapper');

  window.addEventListener("scroll", function() {
    if (header || breadcrumbs) {
      if (window.scrollY <= 30 && header) {
        header.style.backgroundColor = 'transparent';
      } else if (header) {
        header.style.backgroundColor = 'var(--clr-text)';
      }

      if (breadcrumbs && !isMainWrapper) {
        if (window.scrollY <= 30) {
          breadcrumbs.style.display = "inherit";
        } else {
          breadcrumbs.style.display = "none";
        }
      }
    }
  });
});
